import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        classifiers: '=',
        sites: '='
    },
    template: `
        <div class="col00">
            <div class="heading01 type01">
                <h1>{{ 'reports.Courses in progress' | translate }}</h1>
            </div>
            <reports-courseprogress-filter
                list="vm.list"
                filter="vm.filter"
                default-filter="vm.defaultFilter"
                classifiers="vm.classifiers"
                filter-overview="vm.filterOverview"
                sites="vm.sites"
                selected-items="vm.selectedItems"
            />
            <div class="well">
                <div class="heading01">
                    <h2>{{ 'reports.Report' | translate }}</h2>
                    <ul class="actions01">
                        <li>
                            <a ng-if="!vm.list.loading && vm.PrivilegeService.isCompanyAdmin()" class="btn ico-view" ng-click="vm.showBulk = !vm.showBulk">
                                {{ 'reports.Show bulk actions' | translate }}
                            </a>
                        </li>
                        <li><a ng-click="vm.exportCsv()" class="btn ico-download">{{ 'reports.Export as csv' | translate }}</a></li>
                    </ul>
                </div>
                <reports-filter-overview filter-overview="vm.filterOverview"></reports-filter-overview>
                <pagination-tools list="vm.list" custom-options="[1000]"></pagination-tools>
                <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
                <div class="" ng-if="!vm.list.loading && vm.list.items.length">
                    <reports-courseprogress-table show-bulk="vm.showBulk" selected-items="vm.selectedItems" items="vm.list.items"/>
                    <pagination list="vm.list"></pagination>
                    <reports-courseprogress-bulk
                        ng-if="vm.showBulk"
                        list="vm.list"
                        filter="vm.filter"
                        selected-items="vm.selectedItems"
                    />
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($window, lodash, ListFactory,
                 CourseResource, AuthResource,
                 PrivilegeService, ReportService, TokenService,
                 COURSE_STATUS_TYPE_ENUM, USER_STATUS_ENUM, COURSE_TARGET_NEED_TYPE_ENUM, USER_ACTIVATION_STATUS_ENUM) {
        this.$window = $window;
        this.lodash = lodash;
        this.AuthResource = AuthResource;
        this.PrivilegeService = PrivilegeService;
        this.ReportService = ReportService;
        this.TokenService = TokenService;
        this.COURSE_STATUS_TYPE_ENUM = COURSE_STATUS_TYPE_ENUM;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.COURSE_TARGET_NEED_TYPE_ENUM = COURSE_TARGET_NEED_TYPE_ENUM;
        this.USER_ACTIVATION_STATUS_ENUM = USER_ACTIVATION_STATUS_ENUM;
        this.list = ListFactory.createWithPagination(CourseResource.userCourseProgressReport.bind(CourseResource));
    }

    $onInit () {
        this.defaultFilter = {};
        // this means all sites are accessible and no point in choosing them
        this.filterOverview = { };
        if (this.lodash.isEmpty(this.defaultFilter)) {
            this.defaultFilter = {
                departmentIds: [],
                siteIds: this.sites.map(site => site.id),
                levelIds: [],
                roleIds: [],
                statuses: [
                    this.COURSE_STATUS_TYPE_ENUM.KEYS.NOT_STARTED,
                    this.COURSE_STATUS_TYPE_ENUM.KEYS.IN_PROGRESS
                ],
                participationTypes: [
                    this.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.COMPULSORY,
                    this.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.OPTIONAL
                ],
                employeeStatuses: [this.USER_STATUS_ENUM.KEYS.ACTIVE, this.USER_STATUS_ENUM.KEYS.NOT_STARTED],
                employeeAccounts: [this.USER_ACTIVATION_STATUS_ENUM.KEYS.ACTIVATED, this.USER_ACTIVATION_STATUS_ENUM.KEYS.NOT_ACTIVATED],
                pageSize: 25
            };
        }

        this.filter = angular.copy(this.defaultFilter);
        this.list.fetch({}, this.filter);
        this.selectedItems = [];

        this.filters = JSON.parse(this.$window.localStorage.getItem('is_user_results_report_filter_opened'));
    }

    exportCsv () {
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const filter = angular.copy(this.filter);
                filter['siteIds[]'] = this.filter.siteIds;
                filter['statuses[]'] = this.filter.statuses;
                filter['participationTypes[]'] = this.filter.participationTypes;
                filter['employeeStatuses[]'] = this.filter.employeeStatuses;
                filter['employeeAccounts[]'] = this.filter.employeeAccounts;
                filter['roleIds[]'] = this.filter.roleIds;
                filter['levelIds[]'] = this.filter.levelIds;
                filter['departmentIds[]'] = this.filter.departmentIds;

                const qs = this.ReportService.buildQueryString(filter);
                const lang = this.TokenService.getActiveLanguage(true);
                const url = `${SEED_CORE.ENV.API_URL}course/course/user-course-progress-report-export?tacToken=${token}&${qs}&_lang=${lang}`;
                this.$window.open(url);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/courseprogress/index.js